export default __webpack_public_path__ + "static/media/expand.20e3102a.svg";